<template>
  <div>
    <b-card no-body class="mb-2">
      <b-card-header>
        <b-row align-v="center">
          <b-col cols="auto" class="mr-auto">
            <h5 class="">Документы</h5>
          </b-col>
          <b-col cols="auto">
            <b-button size="sm" variant="success" @click="onAdd" :disabled="isDisabled">
              <font-awesome-icon icon="plus" class="mr-1"/>
              Добавить
            </b-button>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card no-body class="mx-0 border-0">
        <b-table
          id="task-files"
          ref="task_files"
          class="mb-0"
          selectable
          select-mode="single"
          selectedVariant="success"
          striped
          small
          thead-class="top-fixed-thead thead-light"
          table-class="text-small"
          responsive
          show-empty
          :empty-text="$t('message.common.emptyTable')"
          :busy="isBusy"
          :items="items"
          :fields="fields"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Загрузка</strong>
            </div>
          </template>

          <template #cell(path)="row">
            <b-link @click="onDownload(row.item.id, row.item.path)">{{row.item.path}}</b-link>
          </template>

          <template #cell(action)="row">
            <b-button size="sm" variant="danger" @click="onRemove(row)" :disabled="isDisabled" class="ml-3">
              <font-awesome-icon icon="trash" />
            </b-button>
          </template>
        </b-table>
      </b-card>

      <b-card-footer footer-bg-variant="light">
        <b-row align-h="between" align-v="center">
          <b-col cols="auto" class="mr-auto">
            Всего файлов: <b>{{items.length}}</b>
          </b-col>
          <b-col cols="auto">
            <b-pagination
              id="task-files-pagination"
              pills
              :total-rows="items.length"
              :per-page="perPage"
              v-model="currentPage"/>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>

    <b-modal
      id="modal-file"
      ref="modal_file"
      title="Загрузка файла"
      @show="onResetModal"
      @hidden="onResetModal"
      ok-title="Добавить"
      ok-variant="success"
      cancel-title="Отменить"
      @ok="onOk"
      button-size="sm"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-file
          id="input_number"
          size="sm"
          autocomplete="off"
          v-model="newFile">
        </b-form-file>
      </form>
    </b-modal>
  </div>
</template>

<script>
import tasks from "../../network/tasks";
  import helpers from "../../utilites/helpers";

export default {
  name: "TaskFiles",
  mixins: [
    tasks,
    helpers
  ],
  props: {
    isDisabled: Boolean,
  },
  data() {
    return {
      task_id: 0,
      newFile: null,
      items: [],
      fields: [
        {
          key: 'path',
          label: 'Файл',
          class: 'text-center'
        },
        {
          key: 'action',
          label: 'Действие',
          class: 'widthAction'
        },
      ],
      perPage: 10,
      currentPage: 1,
      isBusy: false,
      deleteRow: {
        id: null,
        path: ''
      },
    }
  },
  methods: {
    configure(taskId) {
      this.task_id = taskId;
      this.getItems();
    },
    async getItems() {
      this.isBusy = true;
      const result = await this.getTaskFilesByTaskId(this.task_id);
      this.isBusy = false;

      this.items = result.data;
    },
    onAdd() {
      if (this.task_id === 0) {
        const message = `Сначала создайте заявку. Нажмите кнопку "Сохранить"`
        this.$bvToast.toast(message, {
          title: 'Ошибка добавления файла',
          variant: 'danger',
          autoHideDelay: 3000,
          solid: true
        });
        return;
      }

      this.$bvModal.show('modal-file');
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление файла";
      const message = `Вы действительно хотите удалить файл ${this.deleteRow.path}?`;
      this.showModalDelete(title, message, function () {
        this.removeItem(this.deleteRow);
      }.bind(this));
    },
    onResetModal() {
      this.newFile = null;
    },
    onOk(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmit();
    },
    async handleSubmit() {
      if (!this.newFile) return;

      let formData = new FormData();
      formData.append("file", this.newFile, this.newFile.name);

      const result = await this.postTaskFile(this.task_id, formData);

      if (result.error !=null) {
        console.log(result.error);
        return;
      }

      this.$nextTick(() => {
        this.$bvModal.hide('modal-file');
      })

      await this.getItems();
    },
    async onDownload(id, fileName) {
      const result = await this.getTaskFile(id);

      if (!result.data) return;

      this.handleFileDownload(result.data, fileName);
    },
    async removeItem(item) {
      const result = await this.deleteTaskFile(item.id);
      if (result.data == null) {
        return;
      }
      await this.getItems();
    }
  }
}
</script>

<style>
#task-files td {
  text-align: left;
  vertical-align: middle;
}

#task-files th {
  text-align: left;
  vertical-align: middle;
}

#task-files-pagination {
  margin-bottom: 0;
}

.widthId {
  width: 100px;
}
.widthComment {
  width: 200px;
}
.widthAction {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/Tasks/TaskFiles.vue